import { QRWifi } from "./qr-wifi";

export { QRWifi };
